<template>
  <div class="login">
    <img
      src="@/assets/login/상단 텍스트_아이콘_small.svg"
      v-if="windowWidth <= 500"
      class="ma-5 pt-5"
    />
    <div class="login-more ">
      <div class="justify-center align-center d-flex width-height">
        <div>
          <v-row class=" justify-center d-flex pb-3">
            <img
              src="@/assets/login/상단 텍스트_아이콘.svg"
              v-if="windowWidth > 500"
            />
            <h2 v-if="windowWidth <= 500" class="font-40">LOGIN</h2>
          </v-row>
          <v-row>
            <v-card width="407" height="291" class="pa-40 card">
              <v-row>
                <input
                  placeholder="아이디를 입력해주세요."
                  class="input"
                  v-model="id"
                  @keyup.enter="$refs.password.focus()"
                />
              </v-row>
              <v-row class="pt-4">
                <input
                  placeholder="비밀번호를 입력해주세요."
                  class="input"
                  v-model="password"
                  type="password"
                  @keyup.enter="login"
                  ref="password"
                />
              </v-row>
              <v-row
                width="79"
                height="19"
                class=" align-center d-flex pt-2 pb-5"
              >
                <input type="checkbox" v-model="autoLogin" />
                <span @click="autoLogin = !autoLogin" class="color-white pl-2 ">
                  자동로그인</span
                >
              </v-row>
              <v-row>
                <v-btn
                  class="login-Btn"
                  @click="login()"
                  :width="windowWidth > 500 ? 336 : 299"
                  >login</v-btn
                >
              </v-row>
            </v-card>
          </v-row>
          <v-row class=" justify-center d-flex">
            <v-btn
              @click="
                $router.push({ name: 'IdFind', params: { idCheck: true } })
              "
              class="btn"
              >아이디 찾기</v-btn
            >
            <h2>/</h2>
            <v-btn
              @click="
                $router.push({ name: 'PassFind', params: { idCheck: false } })
              "
              class="btn"
              >비밀번호 찾기</v-btn
            >
          </v-row>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import UserApi from "@/api/UserService";
import AppSettingAPI from "@/api/AppSettingService";
import Mobile from "@/mixin/Mobile";

export default {
  mixins: [Mobile],
  data: () => ({
    id: "",
    password: "",
    autoLogin: true,
    tempImage: "",
  }),

  computed: {
    userId() {
      return this.$store.getters.getUserList.userId;
    },
  },

  methods: {
    async login() {
      let data = {
        accountName: this.id,
        accountPassword: this.password,
        autoLogin: this.autoLogin,
      };
      let returnData = await UserApi.userLogin(data);
      if (returnData.data.success == "fail") {
        this.password = "";
        this.$bus.$emit(
          "dialog",
          "로그인에 실패하셨습니다. 다시 시도해주세요."
        );
      } else {
        let data = await UserApi.userInformaion({
          userId: returnData.data.user.userId,
        });
        this.$store.commit("userListChange", data.data.userInformation);
        let status;
        if (this.qrText) {
          status = {
            name: "qrCode",
            query: {
              qrText: this.qrText,
            },
          };
        } else {
          status = {
            name: "ChoiceCon",
            params: {
              loginId: this.userId,
            },
          };
        }
        await this.getAppSetting();
        this.$router.push(status);
      }
    },
    async getAppSetting() {
      try {
        let { data } = await AppSettingAPI.appSetting();
        this.$store.commit("projectName", data.addedSettingInfos.projectName);
      } catch (e) {
        console.error(e);
      }
    },
  },
};
</script>

<style scoped>
.font-40 {
  font-size: 40px;
}

.card {
  background: rgba(255, 255, 255, 0.08);
  box-shadow: 0px 4px 4px rgba(35, 62, 111, 0.3);
  border-radius: 15px;
  z-index: 1;
}

.pa-40 {
  padding: 40px;
}

.btn {
  color: white !important;
  background-color: transparent !important;
  box-shadow: none !important;
}

h2 {
  color: white;
}

.width-height {
  width: 100%;
  height: 100%;
}

.row {
  margin: 0px !important;
}

.input {
  width: 336px;
  height: 46px;
  border-radius: 0px;
  border: 1px solid #ffffff33;
  padding-left: 12px;
  color: white;
}

.login-Btn {
  height: 62px !important;
  background: #68bae8 !important;
  color: white !important;
  font-style: Bold;
  font-size: 18px !important;
  border-radius: 100px !important;
  left: 0px;
  top: 0px;
}

.login {
  background-image: url(../../assets/login/login.svg);
  top: 0;
  left: 0;
  position: absolute;
  background-size: 100%;

  content: "";
  width: 100%;
  height: 100%;
}

.login-more {
  top: 0;
  left: 0;
  position: absolute;
  background-size: 100%;
  opacity: 0.8;
  z-index: -1;
  width: 100%;
  height: 100%;
  background: linear-gradient(180deg, #1e3c72 0%, #2a5298 100%),
    linear-gradient(0deg, #ffffff, #ffffff);
}

.login {
  height: 100%;
  position: relative;
  z-index: 1;
  border-radius: 30px !important;
}

.input::placeholder {
  color: white;
}
</style>
